import { Link, useNavigate } from "react-router-dom";
import { ROUTES, BASE_URL, ERROR } from "../assets/constant";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import Messages from "../components/message";
import axios from "axios";
import recalllogo from "../assets/images/recalllogo.png";
import { useState } from "react";
import { CustomModal } from "../components/custom-modal";

export const ForgotPassword = () => {
  const [form, setForm] = useState({});
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${BASE_URL}/users/forgot-password`, {
        email: form.email
      });
      setShowModal(true);
    } catch (error) {
      setAlertType(ERROR);
      setAlertMessage(error?.response?.data?.message || "Something went wrong");
      setShowAlert(true);
    }
  };

  const inserData = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  return (
    <div className="login-page">
      <Container className="d-flex justify-content-center align-items-center vh-100">
        <Row className="login-container">
          {/* Image Section */}
          <Col md={6} className="image-section"></Col>

          {/* Form Section */}
          <Col md={6} className="form-section">
            <img src={recalllogo} alt="" />
            <Form onSubmit={handleSubmit}>
              {showAlert && (
                <Messages
                  type={alertType}
                  message={alertMessage}
                  onClose={() => setShowAlert(false)}
                />
              )}
              {showModal && (
                <CustomModal
                  isOpen={showModal}
                  heading="Password Reset Link"
                  text="If you are registered with us, you will recieve a password reset email !!!"
                  closeModal={() => navigate(ROUTES.LOGIN)}
                  btnName={"OK"}
                  onClick={() => navigate(ROUTES.LOGIN)}
                />
              )}
              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter your email"
                  onChange={(e) => inserData("email", e.target.value)}
                  required
                />
              </Form.Group>
              <Button
                variant="primary"
                type="submit"
                className="recallButton"
                style={{
                  marginTop: "20px",
                  borderRadius: "5px",
                  padding: "10px 20px"
                }}>
                Submit
              </Button>

              <div
                to={ROUTES.LOGIN}
                style={{
                  color: "#000",
                  textDecoration: "none"
                }}
                className="text-center d-block mt-4">
                Already have an account? <Link to={ROUTES.LOGIN}>Login</Link>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
